<div class="header">
  <div class="header-brand">
    <!-- Tenant logo when the caller's org has set one, Irisel's otherwise.
         A tenant logo with no link_url renders unlinked rather than pointing
         their users at irisel.com. -->
    <a *ngIf="headerLogoLink" [href]="headerLogoLink" target="_blank" rel="noopener noreferrer"><img [src]="headerLogoUrl" (error)="onHeaderLogoError()" alt="" class="header-logo" /></a>
    <img *ngIf="!headerLogoLink" [src]="headerLogoUrl" (error)="onHeaderLogoError()" alt="" class="header-logo" />
    <h1><a routerLink="/" class="brand-link">{{ 'app.title' | translate }}</a></h1>
  </div>
  <div class="header-user">
    <!-- Language Selector (custom dropdown for flag support) -->
    <div class="lang-dropdown-wrapper" (click)="$event.stopPropagation()">
      <button class="lang-dropdown-toggle" (click)="toggleLanguageDropdown()" type="button" aria-haspopup="listbox" [attr.aria-expanded]="showLanguageDropdown">
        <img *ngIf="currentLang" [src]="'assets/flags/' + currentLang.flag + '.svg'" [alt]="currentLang.label" class="lang-flag" />
        <span *ngIf="currentLang">{{ currentLang.label }}</span>
        <span class="lang-arrow">▾</span>
      </button>
      <ul *ngIf="showLanguageDropdown" class="lang-dropdown-list" role="listbox">
        <li *ngFor="let lang of availableLanguages"
            class="lang-dropdown-item"
            [class.selected]="lang.code === currentLanguage"
            (click)="selectLanguage(lang)"
            role="option"
            [attr.aria-selected]="lang.code === currentLanguage">
          <img [src]="'assets/flags/' + lang.flag + '.svg'" [alt]="lang.label" class="lang-flag" />
          <span>{{ lang.label }}</span>
        </li>
      </ul>
    </div>
    
    <ng-container *ngIf="!user">
      <button class="btn-register" (click)="register()">{{ 'app.register' | translate }}</button>
      <button class="btn-login" (click)="login()">🔐 {{ 'app.login' | translate }}</button>
    </ng-container>
    <ng-container *ngIf="user">
      <div class="user-menu-wrapper">
        <button class="user-avatar" (click)="showUserMenu = !showUserMenu">
          <img *ngIf="user.picture" [src]="user.picture" [alt]="user.name" class="avatar-img" />
          <span *ngIf="!user.picture" class="avatar-initials">{{ userInitials() }}</span>
        </button>
        <span *ngIf="user.balance !== null" class="balance-label">🪙{{ user.balance | localNumber:'1.0-0' }}</span>
        <div *ngIf="showUserMenu" class="user-dropdown">
          <div class="user-dropdown-name">{{ user.name }}</div>
          <div class="user-dropdown-email">{{ user.email }}</div>
          <hr class="user-dropdown-divider" />
          <button class="user-dropdown-item" (click)="showMyAccount()">👤 {{ 'app.myAccount' | translate }}</button>
          <button class="user-dropdown-item" (click)="showContact()">✉️ {{ 'app.contact' | translate }}</button>
          <button class="user-dropdown-item" (click)="showAbout()">ℹ️ {{ 'app.about' | translate }}</button>
          <button class="user-dropdown-item" (click)="logout()">🚪 {{ 'app.logout' | translate }}</button>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Cookie and Data Protection Banner -->
<app-cookie-banner></app-cookie-banner>

<!-- Payment result overlay -->
<div *ngIf="paymentMessage" class="payment-overlay">
  <div class="payment-card">
    <div class="payment-icon">{{ paymentMessage.icon }}</div>
    <h2 class="payment-title" [style.color]="paymentMessage.color">{{ paymentMessage.titleKey | translate }}</h2>
    <p class="payment-text">{{ paymentMessage.textKey | translate }}</p>
    <button class="payment-close-btn" (click)="dismissPaymentMessage()">{{ 'payment.close' | translate }}</button>
  </div>
</div>

<div class="container" *ngIf="isDigitizeRoute">
  <!-- Horizontal Stepper -->
  <div class="stepper">
    <div class="stepper-step"
         [class.active]="currentStep === ProcessingStep.UPLOAD"
         [class.completed]="stepsCompleted.upload"
         (click)="goToStep(ProcessingStep.UPLOAD)">
      <div class="stepper-circle">
        <span *ngIf="!stepsCompleted.upload">1</span>
        <span *ngIf="stepsCompleted.upload">✓</span>
      </div>
      <div class="stepper-label">{{ 'stepper.upload' | translate }}</div>
    </div>

    <div class="stepper-line" [class.completed]="stepsCompleted.upload"></div>

    <div class="stepper-step"
         [class.active]="currentStep === ProcessingStep.CONVERT"
         [class.completed]="stepsCompleted.convert"
         [class.disabled]="!canGoToStep(ProcessingStep.CONVERT)"
         (click)="canGoToStep(ProcessingStep.CONVERT) && goToStep(ProcessingStep.CONVERT)">
      <div class="stepper-circle">
        <span *ngIf="!stepsCompleted.convert">2</span>
        <span *ngIf="stepsCompleted.convert">✓</span>
      </div>
      <div class="stepper-label">{{ 'stepper.convert' | translate }}</div>
    </div>

    <div class="stepper-line" [class.completed]="stepsCompleted.convert"></div>

    <div class="stepper-step"
         [class.active]="currentStep === ProcessingStep.OCR"
         [class.completed]="stepsCompleted.ocr"
         [class.disabled]="!canGoToStep(ProcessingStep.OCR)"
         (click)="canGoToStep(ProcessingStep.OCR) && goToStep(ProcessingStep.OCR)">
      <div class="stepper-circle">
        <span *ngIf="!stepsCompleted.ocr">3</span>
        <span *ngIf="stepsCompleted.ocr">✓</span>
      </div>
      <div class="stepper-label">{{ 'stepper.ocr' | translate }}</div>
    </div>

    <div class="stepper-line" [class.completed]="stepsCompleted.ocr"></div>

    <div class="stepper-step"
         [class.active]="currentStep === ProcessingStep.EXTRACT"
         [class.completed]="stepsCompleted.extract"
         [class.disabled]="!canGoToStep(ProcessingStep.EXTRACT)"
         (click)="canGoToStep(ProcessingStep.EXTRACT) && goToStep(ProcessingStep.EXTRACT)">
      <div class="stepper-circle">
        <span *ngIf="!stepsCompleted.extract">4</span>
        <span *ngIf="stepsCompleted.extract">✓</span>
      </div>
      <div class="stepper-label">{{ 'stepper.extract' | translate }}</div>
    </div>
  </div>

  <!-- Error Display -->
  <div *ngIf="error" class="error-banner">
    <span class="error-icon">⚠️</span>
    <span class="error-text">{{ error }}</span>
  </div>

  <!-- Step Content -->
  <div class="step-content">

    <!-- UPLOAD Step -->
    <div *ngIf="currentStep === ProcessingStep.UPLOAD" class="card">
      <h2>{{ 'upload.title' | translate }}</h2>

      <div *ngIf="showFirstTimeHint" class="first-time-hint">
        <span class="fth-text">{{ 'upload.firstTimeHint' | translate }}</span>
        <button class="fth-close" (click)="dismissFirstTimeHint()" aria-label="Dismiss">&times;</button>
      </div>

      <div *ngIf="!uploadedFile" class="upload-area">
        <input type="file" accept=".pdf,.jpg,.jpeg,.png" #fileInput (change)="onFileSelected($event)" style="display:none">
        <button class="btn-upload" (click)="fileInput.click()">📄 {{ 'upload.choose' | translate }}</button>
        <p class="upload-hint">{{ 'upload.hint' | translate }}</p>
      </div>

      <div *ngIf="uploadedFile" class="file-preview">
        <div class="file-info">
          <span class="file-icon">📄</span>
          <div class="file-details">
            <div class="file-name">{{ uploadedFile.name }}</div>
            <div class="file-size">{{ (uploadedFile.size / 1024).toFixed(2) }} KB</div>
          </div>
          <input type="file" accept=".pdf,.jpg,.jpeg,.png" #fileInputChange (change)="onFileSelected($event)" style="display:none">
          <button class="btn-secondary btn-small" (click)="fileInputChange.click()">{{ 'upload.change' | translate }}</button>
        </div>

        <div class="document-options">
          <div class="option-group" *ngIf="isDeveloper()">
            <label>{{ 'upload.language' | translate }}</label>
            <select [(ngModel)]="selectedLanguage" class="select-input">
              <option *ngFor="let lang of languages" [value]="lang">{{ lang }}</option>
            </select>
          </div>
          <div class="option-group">
            <label>{{ 'upload.resolution' | translate }}</label>
            <select [(ngModel)]="selectedDpi" class="select-input">
              <option *ngFor="let opt of dpiOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <!-- CONVERT Step -->
    <div *ngIf="currentStep === ProcessingStep.CONVERT" class="card">
      <h2>{{ 'convert.title' | translate }}</h2>

      <div *ngIf="isProcessing" class="processing-state">
        <div class="spinner"></div>
        <p>{{ 'convert.processing' | translate }}</p>
      </div>

      <div *ngIf="!isProcessing && imageUrls.length === 0 && !error" class="empty-state">
        <p>{{ 'convert.empty' | translate }}</p>
      </div>

      <div *ngIf="!isProcessing && imageUrls.length > 0" class="image-grid">
        <div *ngFor="let url of imageUrls; let i = index" class="image-thumbnail" (click)="openImagePopup(url, i)">
          <img [src]="url" [alt]="'Page ' + (i + 1)" />
          <div class="image-label">Page {{ i + 1 }}</div>
        </div>
      </div>

      <div *ngIf="!isProcessing && imageUrls.length > 0 && isDeveloper()" class="document-options ocr-tunables">
        <div class="option-group">
          <label>{{ 'convert.ocrBackend' | translate }}</label>
          <select [(ngModel)]="ocrBackend" class="select-input">
            <option value="textract">Cloud OCR (AWS Textract)</option>
            <option value="paddle">Local OCR</option>
          </select>
        </div>
        <div class="option-group">
          <label>{{ 'convert.ocrThreads' | translate }}</label>
          <select [(ngModel)]="ocrCpuThreads" class="select-input">
            <option *ngFor="let opt of ocrThreadOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>
        <div class="option-group">
          <label>{{ 'convert.maxWorkers' | translate }}</label>
          <select [(ngModel)]="ocrMaxWorkers" class="select-input">
            <option *ngFor="let w of ocrMaxWorkersOptions" [value]="w">{{ w }} worker{{ w > 1 ? 's' : '' }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- OCR Step -->
    <div *ngIf="currentStep === ProcessingStep.OCR" class="card">
      <h2>{{ 'ocr.title' | translate }}</h2>

      <!-- Text detection notification -->
      <div *ngIf="hasEmbeddedText && !isProcessing" class="info-message" style="margin-bottom: 1rem;">
        <p>✓ Text-based PDF detected - OCR will be skipped for faster processing</p>
      </div>

      <!-- Force OCR option (only shown if text detected) -->
      <div *ngIf="hasEmbeddedText && !isProcessing && !ocrResult" class="document-options" style="margin-bottom: 1rem;">
        <div class="option-group">
          <label>
            <input type="checkbox" [(ngModel)]="forceOcr" />
            Force OCR (slower, use if text extraction fails)
          </label>
        </div>
      </div>

      <div *ngIf="isProcessing" class="processing-state">
        <div class="spinner"></div>
        <p>{{ 'ocr.processing' | translate }}</p>
      </div>

      <div *ngIf="!isProcessing && ocrResult" class="ocr-result">
        <div class="info-message">
          <p>✅ {{ 'ocr.completed' | translate: {pages: ocrResult.pages} }}<span *ngIf="elapsedTimes['ocr'] !== null"> {{ 'ocr.in' | translate: {time: formatElapsed(elapsedTimes['ocr']!)} }}</span>.</p>
        </div>

        <div class="ocr-download-row">
          <button class="btn-toggle" (click)="downloadOcrText()">
            ⬇ {{ 'ocr.downloadText' | translate }}
          </button>
        </div>

        <!-- OCR billing info -->
        <div *ngIf="shouldShowCostInfo() && ocrResult?.billing_tokens" class="cost-estimate">
          <span>{{ 'ocr.billingTokens' | translate: {tokens: ocrResult.billing_tokens.ocr} }}</span>
        </div>

        <ng-container *ngIf="isDeveloper()">
          <details *ngFor="let page of ocrResult.results" class="ocr-details">
            <summary>{{ page.page }} — {{ page.words }} words, avg confidence: {{ page.avg_confidence }}</summary>
            <div class="ocr-text-list">
              <div *ngFor="let text of page.rec_texts; let i = index" class="ocr-text-row">
                <span class="ocr-score" [style.opacity]="page.rec_scores[i]">{{ (page.rec_scores[i] * 100).toFixed(0) }}%</span>
                <span class="ocr-text">{{ text }}</span>
              </div>
            </div>
          </details>
        </ng-container>

        <div class="document-options">
          <div class="option-group">
            <label>Schema:</label>
            <select [(ngModel)]="selectedSchemaSource" (ngModelChange)="onSchemaSourceChange()" class="select-input">
              <option value="internal">Internal</option>
              <option value="external">External (XSD)</option>
            </select>
          </div>
          <div class="option-group">
            <label>{{ 'ocr.documentType' | translate }}</label>
            <select [(ngModel)]="selectedDocumentType" (ngModelChange)="onDocumentTypeChange()" class="select-input">
              <option *ngFor="let type of activeDocumentTypes" [value]="type">{{ formatDocumentType(type) }}</option>
            </select>
          </div>
        </div>
      </div>

      <div *ngIf="!isProcessing && !ocrResult && !error" class="empty-state">
        <p>{{ 'ocr.empty' | translate }}</p>
      </div>

      <div *ngIf="!isProcessing && error" class="failsafe-hint">
        <p>{{ 'ocr.failsafe' | translate }}</p>
        <button class="btn-failsafe" (click)="executeOCRSimple()">🆘 {{ 'ocr.failsafeButton' | translate }}</button>
      </div>
    </div>

    <!-- EXTRACT Step -->
    <div *ngIf="currentStep === ProcessingStep.EXTRACT" class="card">
      <h2>{{ 'extract.title' | translate }}</h2>

      <div class="document-options" style="margin-bottom:1rem">
        <ng-container *ngIf="isDeveloper()">
          <div class="option-group">
            <label>Backend:</label>
            <select [(ngModel)]="selectedBackend" (ngModelChange)="onBackendChange()" class="select-input" [disabled]="isProcessing">
              <option value="openai">OpenAI</option>
              <option value="ollama">Local AI</option>
              <option value="bedrock">Bedrock</option>
              <option value="local">vLLM</option>
            </select>
          </div>
          <div class="option-group">
            <label>Model:</label>
            <input
              list="model-options"
              [(ngModel)]="selectedModel"
              class="select-input"
              [disabled]="isProcessing"
              placeholder="Select or type model name">
            <datalist id="model-options">
              <option *ngFor="let m of filteredModelOptions" [value]="m">{{ displayModel(m) }} — {{ modelPriceLabel(m) }}</option>
            </datalist>
          </div>
        </ng-container>
        <div class="option-group" *ngIf="selectedSchemaSource !== 'external'">
          <label>{{ 'extract.outputFormat' | translate }}:</label>
          <select [(ngModel)]="selectedOutputFormat" class="select-input" [disabled]="isProcessing">
            <option *ngFor="let fmt of activeOutputFormats" [value]="fmt">{{ fmt | uppercase }}</option>
          </select>
        </div>
      </div>

      <div *ngIf="isProcessing" class="processing-state">
        <div class="spinner"></div>
        <p>{{ 'extract.processing' | translate }}</p>
      </div>

      <div *ngIf="!isProcessing && result">
        <div class="view-toggle">
          <button class="btn-toggle" [class.active]="viewMode === ViewMode.TREE" (click)="viewMode = ViewMode.TREE"
                  *ngIf="!isTableResult() && !isCsvResult()">
            🌳 {{ 'extract.treeView' | translate }}
          </button>
          <button *ngIf="!isXmlResult() && !isTableResult() && !isCsvResult()" class="btn-toggle" [class.active]="viewMode === ViewMode.JSON" (click)="viewMode = ViewMode.JSON">
            &lt;/&gt; JSON
          </button>
          <button *ngIf="isXmlResult() && !isTableResult()" class="btn-toggle" [class.active]="viewMode !== ViewMode.TREE" (click)="viewMode = ViewMode.JSON">
            &lt;/&gt; XML
          </button>
          <button *ngIf="isTableResult()" class="btn-toggle active">
            📊 {{ result.format | uppercase }}
          </button>
          <!-- CSV result buttons -->
          <ng-container *ngIf="isCsvResult()">
            <button class="btn-toggle" [class.active]="viewMode === ViewMode.SPREADSHEET" (click)="viewMode = ViewMode.SPREADSHEET">📊 Spreadsheet</button>
            <button class="btn-toggle" [class.active]="viewMode === ViewMode.JSON" (click)="viewMode = ViewMode.JSON">CSV</button>
          </ng-container>
          <button class="btn-toggle" (click)="downloadResult()">⬇ Download {{ isCsvResult() ? 'CSV' : (isTableResult() ? (result.format | uppercase) : (isXmlResult() ? 'XML' : 'JSON')) }}</button>
        </div>

        <div *ngIf="viewMode === ViewMode.TREE && !isXmlResult()" class="tree-view">
          <div class="tree-container">
            <div class="tree-item">
              <div class="tree-node">
                <span class="tree-key">Document Data</span>
                <span class="tree-type">object</span>
              </div>
              <div class="tree-children">
                <ng-container *ngFor="let key of getVisibleKeys(result)">
                  <div class="tree-item">

                    <!-- ARRAY -->
                    <ng-container *ngIf="isArray(result[key]); else l1Object">
                      <div class="tree-node">
                        <span class="tree-key">{{ key }}</span>
                        <span class="tree-type">array [{{ result[key].length }}]</span>
                      </div>
                      <div class="tree-children">
                        <ng-container *ngFor="let item of result[key]; let i = index">
                          <div class="tree-item">
                            <ng-container *ngIf="isObject(item); else primitiveArrayItem">
                              <div class="tree-node">
                                <span class="tree-key">[{{ i }}]</span>
                                <span class="tree-type">object</span>
                              </div>
                              <div class="tree-children">
                                <div class="tree-item" *ngFor="let subKey of getObjectKeys(item)">
                                  <div class="tree-node">
                                    <span class="tree-key">{{ subKey }}</span>
                                    <span class="tree-value">{{ formatValue(item[subKey]) }}</span>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <ng-template #primitiveArrayItem>
                              <div class="tree-node">
                                <span class="tree-key">[{{ i }}]</span>
                                <span class="tree-value">{{ formatValue(item) }}</span>
                              </div>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <!-- OBJECT -->
                    <ng-template #l1Object>
                      <ng-container *ngIf="isObject(result[key]); else l1Scalar">
                        <div class="tree-node">
                          <span class="tree-key">{{ key }}</span>
                          <span class="tree-type">object</span>
                        </div>
                        <div class="tree-children">
                          <div class="tree-item" *ngFor="let subKey of getObjectKeys(result[key])">
                            <div class="tree-node">
                              <span class="tree-key">{{ subKey }}</span>
                              <span class="tree-value">{{ formatValue(result[key][subKey]) }}</span>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <!-- SCALAR -->
                      <ng-template #l1Scalar>
                        <div class="tree-node">
                          <span class="tree-key">{{ key }}</span>
                          <span class="tree-value">{{ formatValue(result[key]) }}</span>
                        </div>
                      </ng-template>
                    </ng-template>

                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <!-- XML Tree View -->
        <div *ngIf="viewMode === ViewMode.TREE && isXmlResult() && result?.xml" class="tree-view">
          <div class="tree-container">
            <ng-container *ngIf="parsedXmlTree">
              <ng-container *ngTemplateOutlet="xmlNodeTpl; context: { $implicit: parsedXmlTree }"></ng-container>
            </ng-container>
          </div>
        </div>

        <!-- Recursive XML tree node template -->
        <ng-template #xmlNodeTpl let-node>
          <div class="tree-item">
            <div class="tree-node xml-node" (click)="node._collapsed = !node._collapsed">
              <span *ngIf="node.children.length > 0" class="tree-toggle">{{ node._collapsed ? '+' : '−' }}</span>
              <span *ngIf="node.children.length === 0" class="tree-toggle-spacer"></span>
              <span class="tree-key xml-tag">{{ node.tag }}</span>
              <ng-container *ngIf="node.children.length === 0 && node.text">
                <span class="tree-value">{{ node.text }}</span>
              </ng-container>
              <ng-container *ngIf="node.children.length > 0">
                <span class="tree-type">{{ node.children.length }} element{{ node.children.length > 1 ? 's' : '' }}</span>
              </ng-container>
              <ng-container *ngIf="node.attributes && getObjectKeys(node.attributes).length > 0">
                <span class="tree-attr" *ngFor="let attr of getObjectKeys(node.attributes)">
                  {{ attr }}="{{ node.attributes[attr] }}"
                </span>
              </ng-container>
            </div>
            <div *ngIf="node.children.length > 0 && !node._collapsed" class="tree-children">
              <ng-container *ngFor="let child of node.children">
                <ng-container *ngTemplateOutlet="xmlNodeTpl; context: { $implicit: child }"></ng-container>
              </ng-container>
            </div>
          </div>
        </ng-template>

        <div *ngIf="viewMode === ViewMode.JSON && !isXmlResult() && !isCsvResult()" class="json-view">
          <div class="json-result-wrapper">
            <button *ngIf="!isPaywalled" class="copy-btn" (click)="copyResult()" [title]="'Copy JSON'">📋</button>
            <pre class="json-result" [class.paywall-no-select]="isPaywalled">{{ result | json }}</pre>
          </div>
        </div>

        <!-- CSV Spreadsheet View -->
        <div *ngIf="viewMode === ViewMode.SPREADSHEET && isCsvResult() && csvTable" class="spreadsheet-view">
          <div class="spreadsheet-wrapper">
            <table class="spreadsheet-table">
              <thead>
                <tr>
                  <th class="row-index">#</th>
                  <th *ngFor="let h of csvTable.headers">{{ h }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of csvTable.rows; let i = index">
                  <td class="row-index">{{ i + 1 }}</td>
                  <td *ngFor="let cell of row" class="spreadsheet-cell">{{ cell }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- CSV Text View -->
        <div *ngIf="viewMode === ViewMode.JSON && isCsvResult()" class="json-view">
          <div class="json-result-wrapper">
            <button *ngIf="!isPaywalled" class="copy-btn" (click)="copyResult()" [title]="'Copy CSV'">📋</button>
            <pre class="json-result" [class.paywall-no-select]="isPaywalled">{{ result?.csv }}</pre>
          </div>
        </div>

        <!-- XML raw view -->
        <div *ngIf="viewMode !== ViewMode.TREE && isXmlResult() && result?.xml" class="json-view">
          <div class="json-result-wrapper">
            <button *ngIf="!isPaywalled" class="copy-btn" (click)="copyResult()" [title]="'Copy XML'">📋</button>
            <pre class="json-result" [class.paywall-no-select]="isPaywalled">{{ result.xml }}</pre>
          </div>
        </div>

        <!-- XSD validation status (shown in both tree and raw view) -->
        <ng-container *ngIf="isXmlResult() && result?.xml">
          <div *ngIf="result.valid === true" class="success-message" style="margin-top:0.5rem">
            <p>✅ Valid according to schema definition</p>
          </div>
          <div *ngIf="result.valid === false" class="info-message" style="margin-top:0.5rem">
            <p>⚠️ XML has validation warnings — <a href="javascript:void(0)" class="validation-link" (click)="showValidationReport(result.errors)">Validation Report</a></p>
          </div>
          <div *ngIf="result.valid === null" class="info-message" style="margin-top:0.5rem">
            <p>ℹ️ No XSD configured — validation skipped</p>
          </div>
        </ng-container>

        <!-- Table format raw view (CSV, ODF, XLSX) -->
        <div *ngIf="isTableResult() && result?.content" class="json-view">
          <div class="json-result-wrapper">
            <button *ngIf="!isPaywalled" class="copy-btn" (click)="copyResult()" [title]="'Copy ' + (result.format | uppercase)">📋</button>
            <pre class="json-result" [class.paywall-no-select]="isPaywalled">{{ result.content }}</pre>
          </div>
        </div>

        <!-- Cost estimate -->
        <div *ngIf="shouldShowCostInfo() && result?.token_usage" class="cost-estimate">
          <span *ngIf="elapsedTimes['extract'] !== null">⏱ {{ formatElapsed(elapsedTimes['extract']!) }}</span>
          <span *ngIf="isDeveloper()">Model: {{ usedModel }}</span>
          <span>{{ 'extract.billingTokens' | translate: {tokens: billingTokensDisplay()} }}</span>
          <span *ngIf="isDeveloper() && estimatedCost()">Estimated cost: {{ estimatedCost() }}</span>
        </div>

        <!-- Extraction feedback -->
        <div class="extraction-feedback">
          <span>{{ 'extract.feedbackPrompt' | translate }}</span>
          <button class="btn-feedback" [class.selected]="extractionFeedback === 'up'" (click)="sendExtractionFeedback('up')" title="Good extraction">👍</button>
          <button class="btn-feedback" [class.selected]="extractionFeedback === 'down'" (click)="sendExtractionFeedback('down')" title="Poor extraction">👎</button>
        </div>
      </div>

      <div *ngIf="!isProcessing && !result && !error" class="empty-state">
        <p>{{ 'extract.empty' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="action-buttons">
    <button class="btn-secondary" (click)="reset()">🔄 {{ 'actions.startOver' | translate }}</button>
    <button class="btn-secondary" routerLink="/dossiers">📁 {{ 'actions.dossierMode' | translate }}</button>

    <div class="action-buttons-right">
      <!-- Repeat/Extract button: shown on steps 2-4 when not processing -->
      <button
        *ngIf="currentStep !== ProcessingStep.UPLOAD && !isProcessing"
        class="btn-repeat"
        (click)="repeatStep()">
        <span *ngIf="currentStep === ProcessingStep.EXTRACT">📊 Extract</span>
        <span *ngIf="currentStep !== ProcessingStep.EXTRACT">🔁 {{ 'actions.repeat' | translate }}</span>
      </button>

      <!-- Fast-Extract button: shown only on EXTRACT step for developers -->
      <button
        *ngIf="currentStep === ProcessingStep.EXTRACT && !isProcessing && isDeveloper()"
        class="btn-repeat"
        (click)="executeExtractSmallModel()"
        style="margin-left: 0.5rem;">
        ⚡ Fast-Extract (Experimental)
      </button>

      <!-- Next button: shown on steps 1-3 -->
      <button
        *ngIf="currentStep !== ProcessingStep.EXTRACT"
        class="btn-primary"
        [disabled]="!canClickNext()"
        (click)="nextStep()">
        <span *ngIf="!isProcessing">{{ 'actions.next' | translate }} →</span>
        <span *ngIf="isProcessing">{{ 'actions.processing' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- All other routes: render via router outlet -->
<router-outlet *ngIf="!isDigitizeRoute"></router-outlet>

<!-- Footer spacer -->
<div class="footer-spacer"></div>

<!-- Floating Help Button -->
<button class="help-fab" (click)="toggleHelp()" [class.active]="showHelpDialog"
        [attr.aria-label]="'help.button' | translate">
  <span *ngIf="!showHelpDialog">?</span>
  <span *ngIf="showHelpDialog">&#x2715;</span>
</button>

<!-- Help Dialog -->
<div *ngIf="showHelpDialog" class="help-dialog">
  <div class="help-dialog-header">
    <h3>{{ 'help.title' | translate }}</h3>
  </div>
  <div class="help-dialog-body">
    <div *ngIf="helpStatus === 'success'" class="help-success">
      <p>{{ 'help.success' | translate }}</p>
    </div>
    <form *ngIf="helpStatus !== 'success'" (ngSubmit)="sendHelp()">
      <label class="help-label">{{ 'help.emailLabel' | translate }}</label>
      <input type="email" class="help-input" [(ngModel)]="helpEmail" name="helpEmail"
             [placeholder]="'help.emailPlaceholder' | translate" (blur)="validateHelpEmail()" />
      <div *ngIf="helpEmailWarning" class="help-warning">{{ helpEmailWarning }}</div>
      <label class="help-label">{{ 'help.messageLabel' | translate }}</label>
      <textarea class="help-input help-textarea" [(ngModel)]="helpMessage" name="helpMessage"
                [placeholder]="'help.messagePlaceholder' | translate"></textarea>
      <div *ngIf="helpError" class="help-error">{{ helpError }}</div>
      <button type="submit" class="help-submit" [disabled]="helpSending">
        {{ (helpSending ? 'help.sending' : 'help.send') | translate }}
      </button>
    </form>
  </div>
</div>

<!-- Paywall Modal -->
<div class="paywall-overlay" *ngIf="showPaywall" (click)="showPaywall = false">
  <div class="paywall-modal" (click)="$event.stopPropagation()">
    <button class="paywall-close" (click)="showPaywall = false">&times;</button>

    <ng-container *ngIf="auth.user; else registerCta">
      <h3>{{ 'paywall.title' | translate }}</h3>
      <p>{{ 'paywall.text' | translate:{ required: paywallMinBalance } }}</p>
      <p class="paywall-balance">{{ 'paywall.balance' | translate }}: <strong>{{ (auth.user.balance ?? 0) | localNumber:'1.0-0' }} ꝟ</strong></p>
      <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top" class="paywall-form" (click)="$event.stopPropagation()">
        <input type="hidden" name="cmd" value="_s-xclick">
        <input type="hidden" name="hosted_button_id" value="{{paypalHostedButtonId}}">
        <input type="hidden" name="currency_code" value="EUR">
        <input type="hidden" name="custom" value="{{auth.user.email || ''}}">
        <input type="image" src="https://www.paypalobjects.com/webstatic/en_US/i/btn/png/silver-rect-paypal-34px.png" style="border:0;cursor:pointer;vertical-align:middle;" name="submit" title="PayPal" alt="PayPal">
      </form>
    </ng-container>

    <ng-template #registerCta>
      <h3>{{ 'paywall.registerTitle' | translate }}</h3>
      <p>{{ 'paywall.registerText' | translate }}</p>
      <div class="paywall-form">
        <button class="btn btn-primary" (click)="register()">{{ 'app.register' | translate }}</button>
        <button class="btn" (click)="login()">{{ 'app.login' | translate }}</button>
      </div>
    </ng-template>

    <button class="paywall-close-btn" (click)="showPaywall = false">{{ 'paywall.close' | translate }}</button>
  </div>
</div>

<!-- AI Agent Chat Widget -->
<app-agent-chat></app-agent-chat>
